import { ReleaseNotesQueryParams } from '@/api/apis/release-notes';

export const releaseNotesQueryKeys = {
  all: ['release-notes'] as const,
  list: (params?: ReleaseNotesQueryParams) => ['release-notes', 'list', params] as const,
  byId: (id: string) => ['release-notes', 'item', id] as const,
};
